// extracted by mini-css-extract-plugin
export default {"root":"styles_root__Ppw1l","root_item":"styles_root_item__PVtJy"};